<mat-form-field appearance="outline" class="w-full !-mb-[1.25em]">
    <mat-select [formControl]="form.controls.status" panelWidth="w-full">
        @for (
            orderStatus of orderStatusDropdownOptions;
            track orderStatus.value
        ) {
            <mat-option
                [value]="orderStatus.value"
                [disabled]="orderStatus.disabled"
            >
                {{ orderStatus.label }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
